import { SourceItem } from './source-item';

export class SourceImage extends SourceItem {
  public file: string = '';
}
